// extracted by mini-css-extract-plugin
export var tableContainer = "RichText-module--tableContainer--eGvE0";
export var richTextContainer = "RichText-module--richTextContainer--d4KSC";